var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smart-link',{staticClass:"navigation-btn",class:{active: _vm.active, small: _vm.small},attrs:{"to":_vm.to,"aria-current":_vm.ariaCurrent},on:{"click":function($event){return _vm.$gtm.push({
		event: _vm.$GTM_EVENTS.ACCOUNT_NAV_CLICK,
		component: _vm.component,
		label: _vm.title,
	})}}},[_c('count-badge',{staticClass:"icon",attrs:{"count":_vm.count,"size":"large"}},[_c('span',{class:("icon-" + _vm.icon)})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }